<template>
  <main>
    <HeroPage
      title="Candidatos"
      description="Informações dos candidatos"
    ></HeroPage>
    <Breadcrumb :list="breadcrumbList"></Breadcrumb>
    <section>
      <div class="candidates-container">
        <div v-for="(cargo, cargo_id) in cargos" :key="cargo_id" class="mb-10">
          <div class="candidates-header">
            <h5>{{ "0" + cargo.numero + "/" + cargo.nome }}</h5>
          </div>
          <ul>
            <li
              v-for="(candidato, candidato_id) in cargo.candidatos"
              :key="candidato_id"
            >
              <div class="candidate-profile">
                <img
                  v-if="candidato.foto"
                  :src="candidato.foto"
                  alt="avatar"
                  width="135"
                  height="145"
                />
                <div class="w-screen">
                  <div class="candidate-cargo">
                    <h1>{{ candidato.cargo }}</h1>
                  </div>
                  <div class="candidate-name">
                    <h1>{{ candidato.nome }}</h1>
                  </div>
                  <div
                    v-if="candidato.minicurriculo"
                    class="mt-2 text-center pb-2"
                  >
                    <button
                      @click="
                        openModal(
                          'Minicurrículo - ' + candidato.nome,
                          candidato.minicurriculo
                        )
                      "
                      class="
                        text-xs
                        font-semibold
                        text-lime-700
                        hover:text-lime-800
                        focus:outline-none
                        underline
                      "
                    >
                      Ler Minicurrículo
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul v-if="cargo.nomeformatado || cargo.propostas" class="mt-2">
            <li>
              <div
                class="
                  candidate-profile
                  bg-gray-50
                  p-3
                  rounded
                  border border-gray-200
                  text-center
                  flex
                  justify-center
                "
              >
                <button
                  @click="
                    openModal(
                      'Proposta - ' + cargo.nome,
                      cargo.propostas || cargo.nomeformatado
                    )
                  "
                  class="
                    text-sm
                    font-semibold
                    text-lime-700
                    hover:text-lime-800
                    focus:outline-none
                    underline
                  "
                >
                  Ler Proposta da Chapa
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Modal -->
    <ModalText
      :show="isModalOpen"
      :title="modalTitle"
      :content="modalContent"
      @close="isModalOpen = false"
    />
  </main>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import HeroPage from "@/components/HeroPage.vue";
import Breadcrumb from "@/components/elements/Breadcrumb.vue";
import services from "@/services";
import _ from "lodash";
import ModalText from "@/components/elements/ModalText.vue";

export default Vue.extend({
  name: "Candidates",
  components: {
    HeroPage,
    Breadcrumb,
    ModalText,
  },
  data() {
    return {
      titleProposal: "Proposta",
      breadcrumbList: [],
      cargos: [],
      isModalOpen: false,
      modalTitle: "",
      modalContent: "",
    };
  },
  computed: {
    ...mapGetters("eleicaonet", ["getParamHotsite"]),
  },
  methods: {
    ...mapActions(["changeLoading"]),
    decodeHtml(html) {
      if (!html) return "";
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    openModal(title, content) {
      this.modalTitle = title;
      this.modalContent = this.decodeHtml(content);
      this.isModalOpen = true;
    },
  },
  async mounted() {
    this.breadcrumbList = this.$route.meta.breadcrumb;
    let page = this.getParamHotsite.pages.candidatos;
    if (page && page.titleProposal) {
      this.titleProposal = page.titleProposal;
    } else {
      this.titleProposal = "Proposta";
    }
    this.changeLoading(true);
    await services.Eleicaonet.loadCandidates().then((response) => {
      this.changeLoading(false);

      let cargos = response.data;
      cargos = _.orderBy(cargos, ["diretorio", "ordem"]);

      cargos = _.filter(cargos, (cargo) => {
        return cargo.nome !== "BRANCO" && cargo.nome !== "NULO";
      });

      _.forEach(cargos, (cargo) => {
        cargo.candidatos = JSON.parse(cargo.participantes);
      });

      this.cargos = cargos;
    });
  },
});
</script>

<style lang="scss" scoped>
@import "../assets/sass/pages/candidates";
</style>
